import { Company } from '@frontend/data-access';
import { Avatar, Image, Tooltip } from 'antd';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface CompanyAvatarProps {
  company: Company;
  size?: number | 'default' | 'large' | 'small';
  shape?: 'square' | 'circle';
  className?: string;
  showBadge?: boolean;
  badgeSize?: number;
  isClickable?: boolean;
}

const covertName = (name: string) => {
  const splittedStr = name.split(/(\s+)/);
  let str = '';
  splittedStr.forEach((s) => {
    if (s.trim() !== '') {
      str = str.concat(s.trim().charAt(0).toUpperCase());
    }
  });
  return str;
};

export function CompanyAvatar({
  company,
  size = 'default',
  shape = 'square',
  className,
  showBadge = false,
  badgeSize = 20,
  isClickable = true,
}: CompanyAvatarProps) {
  const { t } = useTranslation('common');
  const { publicRuntimeConfig } = getConfig();
  const router = useRouter();

  const handleClick = () => {
    if (company?.id && isClickable) {
      router.push(`/company/${company.id}`);
    }
  };

  return (
    <div className="relative w-fit">
      <Avatar
        size={size}
        shape={shape}
        src={
          company?.logo?.url ||
          `${publicRuntimeConfig.staticFolder}/data/scv-grey-logo.png`
        }
        className={`${className} ${isClickable && 'cursor-pointer'}`}
        onClick={handleClick}
      >
        <span>{company?.name && covertName(company.name)}</span>
      </Avatar>
      {showBadge && (
        <Tooltip placement="right" title={t('scv_portfolio')}>
          <div
            className={`absolute cursor-pointer bg-white rounded-full border border-gray-400 p-[2px] 
        ${
          shape === 'square'
            ? 'bottom-0 right-0 translate-x-1/4 translate-y-1/4'
            : 'bottom-0 right-0'
        }`}
            style={{
              width: badgeSize,
              height: badgeSize,
            }}
            data-test="company-scv-portfolio-badge"
          >
            <div className="flex justify-center items-center w-full h-full">
              <Image
                alt="scv portfolio"
                src={`${publicRuntimeConfig.staticFolder}/svg/scv-portfolio.svg`}
                preview={false}
              />
            </div>
          </div>
        </Tooltip>
      )}
    </div>
  );
}

export default CompanyAvatar;
